<av-search class="fx-flex-1" (queryChange)="queryChange($event)"></av-search>
<div role="list" class="filter-container">
  @for (member of contactsFiltered(); track member) {
  <av-filter-item
    role="listitem"
    [attr.aria-label]="contactNames()?.[member.id]"
    [checked]="isChecked(member.id)()"
    [type]="type()"
    [name]="groupName"
    [value]="member"
    (changed)="selectionChanged($event)"
  >
    {{ contactNames()?.[member.id] }}
  </av-filter-item>
  } @if (isEmptySearch()) {
  <div class="container-pad-sm text-muted" translate>No results found</div>
  }
</div>
